/**
 * @flow
 * @relayHash d71328246395e8b27403a4e71f342f97
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SystemConfigContextQueryVariables = {||};
export type SystemConfigContextQueryResponse = {|
  +SystemConfig: ?{|
    +OnuApi: ?boolean
  |}
|};
export type SystemConfigContextQuery = {|
  variables: SystemConfigContextQueryVariables,
  response: SystemConfigContextQueryResponse,
|};
*/


/*
query SystemConfigContextQuery {
  SystemConfig {
    OnuApi
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "SystemConfig",
    "storageKey": null,
    "args": null,
    "concreteType": "SystemConfig",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "OnuApi",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SystemConfigContextQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SystemConfigContextQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SystemConfigContextQuery",
    "id": null,
    "text": "query SystemConfigContextQuery {\n  SystemConfig {\n    OnuApi\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ff00ac14b54d59216257b9b54204c3ea';
module.exports = node;
